import type {FlexSuiteOutroCustomerStoriesProps} from './types'
import {IconCards} from './IconCards'
import {LogoCards} from './LogoCards'

export function FlexSuiteOutroCustomerStories(props: FlexSuiteOutroCustomerStoriesProps) {
  switch (props.variant) {
    case 'logo-cards':
      return <LogoCards stories={props.stories} />
    case 'icon-cards':
      return <IconCards stories={props.stories} />
  }
}
